import { Horizontal } from './horizontal/horizontal.js';

var Constraints = {
  Horizontal: Horizontal
};

export { Constraints };
//# sourceMappingURL=index.js.map
